/// <amd-module name="Release/Landing/LeftPanel/AllPipelines/FolderUtils" />
import * as Utils_String from "VSS/Core/Util/String";
import { INode, NodeType } from "./Types";

import * as Resources from "Release/Landing/Resources";
import { Folder, ReleaseDefinition } from "Release/Client/Contracts/Release";
import { IActiveDefinitionReference, ActiveDefinitionReferenceType } from "DataProviderContracts";
import { getDefinitionReferenceFromDefinition } from "LandingUtils";

export class FolderUtils {

    public static readonly RootFolderPath: string = "\\";

    public static readonly PathSeparator: string = "\\";

    public static getFolderName(folderNameWithPath: string): string {
        if (FolderUtils.isRootPath(folderNameWithPath)) {
            return Resources.AllDefinitions;
        }

        if (!!folderNameWithPath) {
            let parts = folderNameWithPath.split(FolderUtils.PathSeparator);
            return parts[parts.length - 1];
        }

        return "";
    }

    public static getParentFolderPath = (folder: Folder) => {
        let path: string = folder.path;
        let separatorIndex: number = path.lastIndexOf("\\");
        let parentFolderPath: string = path.substring(0, separatorIndex);

        return parentFolderPath || "\\";
    }

    public static isRootPath(folderPath: string): boolean {
        if (!folderPath) {
            return true;
        }

        if (Utils_String.equals(folderPath, FolderUtils.PathSeparator, true)) {
            return true;
        }

        return false;
    }

    public static isFolder(node: INode): boolean {
        return node.type === NodeType.Folder;
    }

    public static convertFolder(folder: Folder, defaultIsExpanded: boolean): INode {
        return {
            type: NodeType.Folder,
            folder: folder,
            releaseDefinition: {},
            defaultIsExpanded: defaultIsExpanded,
            isExpandable: true
        } as INode;
    }

    public static convertDefinition(definition: ReleaseDefinition): INode {
        return {
            type: NodeType.ReleaseDefinition,
            folder: {},
            releaseDefinition: getDefinitionReferenceFromDefinition(definition, ActiveDefinitionReferenceType.SearchedResult),
            defaultIsExpanded: false,
            isExpandable: false
        } as INode;
    }

    public static convertDefinitionReference(definition: IActiveDefinitionReference): INode {
        return {
            type: NodeType.ReleaseDefinition,
            folder: {},
            releaseDefinition: definition,
            defaultIsExpanded: false,
            isExpandable: false
        } as INode;
    }
}
